<template>
  <div class="index-content clearfix">
    <time-monitor/>
    <div v-if="!(swiths.length===0&&sensors.length === 0)" class="params clearfix" :class="{showClass:!isShowMonitor}">
      <water-parameter/>
      <remote-control/>
    </div>
    <!-- <component-demo/> -->
  </div>
</template>

<script>
import TimeMonitor from '../../components/index/TimeMonitor'
import WaterParameter from '../../components/index/WaterParameter'
import RemoteControl from '../../components/index/RemoteControl'
import indexModule from '../../store/modules/index'
import equipmentSocketModule from '../../store/modules/equipmentSocket'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Index',
  components: {
    TimeMonitor,
    WaterParameter,
    RemoteControl
  },
  data () {
    return {
      loading2: true,
      showClass: false
    }
  },
  computed: {
    ...mapState(indexModule, ['equipmentId', 'isShowMonitor']),
    ...mapState(equipmentSocketModule, ['swiths', 'sensors'])
  },
  mounted () {
    function pagePc () {
      let rootValue = 100
      let pc = rootValue / 1920 // 表示1366的设计图,使用100px的默认值
      let width = window.innerWidth // 当前窗口的宽度
      let height = window.innerHeight // 当前窗口的高度
      let rem = ''
      let currentHeight = (width * 798) / 1920
      if (height < currentHeight) {
      // 当前屏幕高度小于应有的屏幕高度，就需要根据当前屏幕高度重新计算屏幕宽度
        width = (height * 1920) / 798
      }
      rem = width * pc // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应font-size值
      document.documentElement.style.fontSize = rem + 'px'
    }

    pagePc()
    window.onresize = function () {
      pagePc()
    }
    if (this.equipmentId) {
      this.loading2 = true
      this.getEquipmentSocket({
        id: this.equipmentId,
        isGetRealTimeData: false
      })
      this.loading2 = false
    }

    // setTimeout(() => {
    //   if (this.isShowMonitor !== 0) {
    //     this.showClass = true
    //   }
    // }, 100)
    // alert(2222)
  },
  methods: {

    ...mapActions(equipmentSocketModule, ['getEquipmentSocket'])
  },
  watch: {
    async equipmentId (value) {
      if (this.equipmentId) {
        this.loading2 = true
        await this.getEquipmentSocket({
          id: this.equipmentId,
          isGetRealTimeData: false
        })
        this.loading2 = false
      }
    }
  }
}
</script>
<style lang="stylus">
  .showClass .water-parameter li
    width auto
  .showClass .remote-control ul
    justify-content: flex-start;
  .showClass .remote-control ul li
    margin-right 0.3rem
    margin-bottom 0.3rem
</style>

<style lang="stylus" scoped>
.index-content
  display flex
  margin-top 0.15rem
  padding 0.2rem 0 0.2rem 0.2rem
  width 100%
  overflow auto
  top 0.44rem
  position absolute
  z-index 10
  bottom 0.48rem
  .params
    float left
    width 6.83rem
    // width 50vw
    height 100%
    overflow auto
    color black
  .showClass
    width 100%
    .water-parameter
      li
        width auto
    .remote-control
      ul
        justify-content: flex-start;

</style>
